var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Mail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-mail",
    className: "cls-1",
    d: "M6.438,8A2.446,2.446,0,0,0,4,10.438v7.125A2.446,2.446,0,0,0,6.438,20H16.563A2.446,2.446,0,0,0,19,17.563V10.438A2.446,2.446,0,0,0,16.563,8Zm0,1.125H16.563a1.3,1.3,0,0,1,1.313,1.313v.415L11.5,14.3,5.125,10.852v-.415A1.3,1.3,0,0,1,6.438,9.125ZM5.125,12.131l6.108,3.3a.563.563,0,0,0,.535,0l6.108-3.3v5.432a1.3,1.3,0,0,1-1.312,1.313H6.438a1.3,1.3,0,0,1-1.312-1.312Z",
    transform: "translate(-4 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mail);
export default __webpack_public_path__ + "static/media/icons8-mail.9a7fdd45c1102ff6390b91e54a2da9e4.svg";
export { ForwardRef as ReactComponent };